const ChargentCardSupport = Object.freeze([
  'Visa',
  'Mastercard',
  'Discover',
  'American Express',
  'MC Eurocard',
  'UK Maestro',
  'JCB Card',
  'Diners Club',
]);

export default ChargentCardSupport;
